import * as React from "react";
import { Context } from "@grandvisionhq/carts-v2";
import { useSelector, useDispatch } from "@grandvisionhq/state";
import { selectPickupPoint, selectStore, selectShippingMethod } from "../../../../StepShipping/StepShipping/actions.js";
import { getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint } from "../../../../StepShipping/StepShipping/selectors.js";
import { isPickupPoint, isPickupStore } from "../../../../utils/utils/shipping-method.js";
const useRestoreCartShippingMethod = () => {
  const shippingMethod = useSelector(getSelectedShippingMethod);
  const { cart } = Context.useCart();
  const dispatch = useDispatch();
  const selectedStore = useSelector(getSelectedStore);
  const selectedPickupPoint = useSelector(getSelectedPickupPoint);
  const restoreShippingMethod = React.useCallback(() => {
    if (shippingMethod?.method && isPickupPoint(shippingMethod?.method) && selectedPickupPoint) {
      dispatch(selectPickupPoint({ pickupPoint: void 0 }));
    }
    if (shippingMethod?.method && isPickupStore(shippingMethod?.method) && selectedStore) {
      dispatch(selectStore({ store: void 0 }));
    }
    if (shippingMethod?.method !== cart?.shippingMethod?.key) {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: cart?.shippingMethod?.key,
            isValid: true,
            isTouched: true
          }
        })
      );
    } else {
      dispatch(
        selectShippingMethod({
          shippingMethod: {
            method: void 0,
            isValid: false,
            isTouched: false
          }
        })
      );
    }
  }, [
    shippingMethod?.method,
    selectedPickupPoint,
    selectedStore,
    cart?.shippingMethod?.key,
    dispatch
  ]);
  return { restoreShippingMethod };
};
export {
  useRestoreCartShippingMethod
};
//# sourceMappingURL=use-restore-cart-shipping-method.js.map
